import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

interface IProps {
    children: React.ReactNode
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            staleTime: 1000 * 60 * 5,
            // refetchOnWindowFocus: true,
        },
    },
})

export function ReactQuery({ children }: IProps) {
    const isProduction = import.meta.env.PROD

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {!isProduction && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    )
}
